import React, { useState } from "react";
import {
    CurrentQuoteTableBox,
    CurrentQuoteTableWrap,
    CurrentQuotesWrap,
} from "./CompareQuoteStyled";
import {
    Box,
    Pagination,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
    Tooltip,
    Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import chatIcon from "../../images/Group 124044.svg";
import calculatorIcon from "../../images/calculatorIcon.svg";
import contactIcon from "../../images/contactIcon.svg";
import percentageIcon from "../../images/percentageIcon.svg";

import AccountDataInfoCard, {
    AccountDataRevenueCard,
} from "./AccountDataInfoCard";
import { Constants } from "./Content";
import { Content } from "../utilities/Table/Content";
import { CurrentToolTip } from "./Data";

const CurrentQuotesAccordian = ({
    currentQuote,
    headers,
    isCurrentVisible,
    isLoading
}) => {
    const [pageNumber, setPageNumber] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = React.useState("desc");
    const [orderBy, setOrderBy] = useState("");
    const handleChangePage = (event, newPage) => {
        setPageNumber(newPage);
    };
    const createSortHandler = (property) => (event) => {
        setOrder(order === "asc" ? "desc" : "asc");
        setOrderBy(property);
        console.log(property);
    };
    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }
    function getComparator(order, orderBy) {
        return order === "desc"
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array?.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis?.map((el) => el[0]);
    }
    return (
        <CurrentQuotesWrap>
            {isCurrentVisible ? (
                <Accordion defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        className="currentHeadingBox"
                    >
                        <div className="noBundleText">
                            {Constants.CURRENT}
                            <Tooltip
                                title={<span className="tooltip">{CurrentToolTip}</span>}
                            >
                                <InfoOutlinedIcon />
                            </Tooltip>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        {currentQuote?.quoteDetails?.length > 0 ? (
                            <>
                                <Box className="accountDataBox">
                                    <AccountDataInfoCard
                                        icon={<img src={calculatorIcon} alt="" />}
                                        data={currentQuote?.accountName}
                                        header={"Account Name"}
                                    />

                                    <AccountDataInfoCard
                                        icon={<img src={chatIcon} alt="" />}
                                        data={
                                            currentQuote?.otherDetails?.brokerConsultantName ?? "--"
                                        }
                                        header={"Broker/Consultant"}
                                    />
                                    <AccountDataInfoCard
                                        icon={<img src={contactIcon} alt="" />}
                                        data={currentQuote?.otherDetails?.totalHeadCount.toLocaleString()}
                                        header={"Total Headcount"}
                                    />
                                    <AccountDataInfoCard
                                        icon={<img src={percentageIcon} alt="" />}
                                        data={
                                            currentQuote?.otherDetails?.brokerCommission
                                                ? currentQuote?.otherDetails?.brokerCommission + " %"
                                                : "0 %"
                                        }
                                        header={"Broker Commisson"}
                                    />
                                </Box>
                                <CurrentQuoteTableBox>
                                    <CurrentQuoteTableWrap component={Paper}>
                                        <Box className="tableContainer">
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        {Object.keys(headers).map((key) => (
                                                            <TableCell
                                                                sx={{
                                                                    color: "#2e598f",
                                                                }}
                                                            >
                                                                <div>
                                                                    <span>{headers[key]}</span>
                                                                    {headers[key] === headers.opportunityName && (
                                                                        <TableSortLabel
                                                                            active
                                                                            direction={
                                                                                orderBy === key ? order : "desc"
                                                                            }
                                                                            onClick={createSortHandler(key)}
                                                                        ></TableSortLabel>
                                                                    )}
                                                                </div>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {currentQuote?.quoteDetails?.length > 0 &&
                                                        stableSort(
                                                            currentQuote?.quoteDetails,
                                                            getComparator(order, orderBy)
                                                        )
                                                            .slice(
                                                                (Number(pageNumber) - 1) * rowsPerPage,
                                                                (Number(pageNumber) - 1) * rowsPerPage +
                                                                rowsPerPage
                                                            )
                                                            .map((quote) => (
                                                                <TableRow>
                                                                    {Object.keys(headers).map((key) => (
                                                                        <TableCell>
                                                                            {quote[key]?.toLocaleString("en", {
                                                                                useGrouping: true,
                                                                                roundingMode: "trunc",
                                                                                maximumFractionDigits: 2,
                                                                                minimumFractionDigits: 2,
                                                                            })}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            ))}
                                                </TableBody>
                                            </Table>
                                        </Box>
                                    </CurrentQuoteTableWrap>
                                    <Box className="paginationContainer">
                                        <Typography variant="h6">
                                            {currentQuote?.quoteDetails?.length}
                                            <span>{Content.TOTAL_RESULT}</span>
                                        </Typography>
                                        <Pagination
                                            sx={{
                                                fontFamily: '"Noto Sans", sans-serif',
                                            }}
                                            count={Math.ceil(
                                                currentQuote?.quoteDetails?.length / rowsPerPage
                                            )}
                                            page={pageNumber}
                                            onChange={handleChangePage}
                                        />
                                    </Box>
                                </CurrentQuoteTableBox>
                                <Box className="accountDataBox">
                                    <AccountDataRevenueCard
                                        data={`${currentQuote?.otherDetails?.totalRevenueInclComm
                                            ? `${currentQuote?.otherDetails?.accountCurrency ?? ""
                                            } ${currentQuote?.otherDetails?.totalRevenueInclComm.toLocaleString("en", {
                                                useGrouping: true,
                                                roundingMode: "trunc",
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2,
                                            })}`
                                            : ""
                                            }`}
                                        header={"Total Revenue"}
                                        subheader={"(Incl. commission)"}
                                    />
                                    <AccountDataRevenueCard
                                        data={`${currentQuote?.otherDetails?.annualRevenueForWPOWOCom
                                            ? `${currentQuote?.otherDetails?.accountCurrency ?? ""
                                            } ${currentQuote?.otherDetails?.annualRevenueForWPOWOCom.toLocaleString("en", {
                                                useGrouping: true,
                                                roundingMode: "trunc",
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2,
                                            })}`
                                            : ""
                                            }`}
                                        header={"Annual Revenue for WPO"}
                                        subheader={"(W/o commission)"}
                                    />
                                    <AccountDataRevenueCard
                                        data={`${currentQuote?.otherDetails?.usdTotalRevenueInclComm
                                            ? `USD ${currentQuote?.otherDetails?.usdTotalRevenueInclComm.toLocaleString("en", {
                                                useGrouping: true,
                                                roundingMode: "trunc",
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2,
                                            })}`
                                            : ""
                                            }`}
                                        header={"USD Total Revenue"}
                                        subheader={"(Incl. commission)"}
                                    />
                                    <AccountDataRevenueCard
                                        data={`${currentQuote?.otherDetails?.usdAnnualRevenueForWPOWOCom
                                            ? `USD ${currentQuote?.otherDetails?.usdAnnualRevenueForWPOWOCom.toLocaleString("en", {
                                                useGrouping: true,
                                                roundingMode: "trunc",
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2,
                                            })}`
                                            : ""
                                            }`}
                                        header={"USD Annual Revenue for WPO"}
                                        subheader={"(W/o commission)"}
                                    />
                                </Box>
                            </>
                        ) : (
                            <Box className="currentNoData">{isLoading ? Constants.FETCHINGDATA : Constants.CURRENTNODATATEXT}</Box>
                        )}
                    </AccordionDetails>
                </Accordion>
            ) : (
                <Accordion disabled defaultExpanded>
                    <AccordionSummary aria-controls="panel3-content" id="panel3-header">
                        <div className="noBundleText">
                            <strong>{Constants.CURRENT}</strong>
                            <InfoOutlinedIcon />
                            {Constants.NOCURRENTTEXT}
                        </div>
                    </AccordionSummary>
                </Accordion>
            )}
        </CurrentQuotesWrap>
    );
};

export default CurrentQuotesAccordian;
